import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { TrendingUp, TrendingDown } from '@mui/icons-material';

const KpiCard = ({ 
  title, 
  value, 
  subtitle, 
  trend, 
  trendValue,
  icon, 
  color = '#0d9488',
  formatter = (val) => val?.toLocaleString() || '0'
}) => {
  const isPositiveTrend = trend === 'up' || (typeof trendValue === 'number' && trendValue > 0);
  
  return (
    <Card sx={{ 
      height: '100%', 
      border: '1px solid #e2e8f0',
      '&:hover': {
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        transform: 'translateY(-2px)',
        transition: 'all 0.3s ease'
      }
    }}>
      <CardContent sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
          <Box sx={{ flex: 1 }}>
            <Typography 
              variant="body2" 
              sx={{ 
                color: '#64748b', 
                fontWeight: 600, 
                textTransform: 'uppercase', 
                letterSpacing: 1, 
                mb: 1,
                fontSize: '0.75rem'
              }}
            >
              {title}
            </Typography>
            <Typography 
              variant="h3" 
              component="div" 
              sx={{ 
                color: '#0f172a', 
                fontWeight: 700, 
                mb: 0.5,
                fontSize: '1.875rem'
              }}
            >
              {formatter(value)}
            </Typography>
            {subtitle && (
              <Typography variant="body2" sx={{ color: '#94a3b8', fontSize: '0.8rem' }}>
                {subtitle}
              </Typography>
            )}
            {(trend || trendValue !== undefined) && (
              <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                {isPositiveTrend ? (
                  <TrendingUp sx={{ fontSize: 16, color: '#10b981', mr: 0.5 }} />
                ) : (
                  <TrendingDown sx={{ fontSize: 16, color: '#ef4444', mr: 0.5 }} />
                )}
                <Typography 
                  variant="body2" 
                  sx={{ 
                    color: isPositiveTrend ? '#10b981' : '#ef4444', 
                    fontWeight: 600,
                    fontSize: '0.75rem'
                  }}
                >
                  {trendValue !== undefined ? `${trendValue > 0 ? '+' : ''}${trendValue}%` : trend}
                </Typography>
              </Box>
            )}
          </Box>
          {icon && (
            <Box
              sx={{
                width: 56,
                height: 56,
                background: `linear-gradient(135deg, ${color}20, ${color}10)`,
                borderRadius: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: `1px solid ${color}30`
              }}
            >
              {React.cloneElement(icon, { sx: { color, fontSize: 28 } })}
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default KpiCard;
